export const apiErrorText =
  'Something went wrong and we were unable to save. Please try again later.'
